import { Box } from "@mui/material";

const sizeGroups = {
  S: ["6M", "2Y"],
  M: ["12M", "4Y"],
  L: ["12M", "6Y"],
};

const sizes = ["XS", "S", "M", "L", "XL", "2XL", "3XL", "MIX"];

export default function SizeHeader() {
  return (
    <Box sx={{ display: "flex" }}>
      {/* Color column */}
      <Box
        sx={{
          minWidth: "110px",
          border: "1px solid black",
          textAlign: "center",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        Color
      </Box>

      {/* Sizes */}
      {sizes.map((size) =>
        sizeGroups[size] ? (
          // Grouped size (S, M, L)
          <Box
            key={size}
            sx={{
              display: "flex",
              flexDirection: "column-reverse", // flip children below parent
              border: "1px solid black",
            }}
          >
            {/* Parent size */}
            <Box
              sx={{
                borderTop: "1px solid black",
                textAlign: "center",
                fontWeight: "bold",
                minHeight: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {size==='S'?'Small':size==='M'?'Medium':size==='L'?'Large':size}
            </Box>

            {/* Sub-sizes on top */}
            <Box sx={{ display: "flex" }}>
              {sizeGroups[size].map((child, i) => (
                <Box
                  key={child}
                  sx={{
                    borderRight: i !== sizeGroups[size].length - 1 ? "1px solid black" : "none",
                    textAlign: "center",
                    minWidth: "70px",
                    minHeight: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "0.85rem",
                  }}
                >
                  {child}
                </Box>
              ))}
            </Box>
          </Box>
        ) : (
          // Single size
          <Box
            key={size}
            sx={{
              minWidth: "100px",
              border: "1px solid black",
              textAlign: "center",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {size}
          </Box>
        )
      )}

      {/* Extra headers */}
      <Box
        sx={{
          minWidth: "100px",
          border: "1px solid black",
          textAlign: "center",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Available
      </Box>
      <Box
        sx={{
          minWidth: "100px",
          border: "1px solid black",
          textAlign: "center",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Price
      </Box>
      <Box
        sx={{
          minWidth: "100px",
          border: "1px solid black",
          textAlign: "center",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Total
      </Box>
      <Box
        sx={{
          minWidth: "80px",
          border: "1px solid black",
          textAlign: "center",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Action
      </Box>
    </Box>
  );
}
